import { combineReducers } from 'redux';
// import { debug } from '../../utils';
// const log = debug('lego:models/reducers');

import { routerReducer as routing } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import MAP from './Map/reducers';
const { mapComponent, mapStateReducers } = MAP;

import accountReducers from './Account/reducers';
const { account } = accountReducers;

import searchReducers from './Search/reducers';
const { queries } = searchReducers;

import placesReducers from './Places/reducers';
const { places } = placesReducers;

import profileReducers from './Profile/reducers';
const { profile } = profileReducers;

import authReducers from './Auth/reducers';
const { auth, cookie } = authReducers;

import locationReducers from './Location/reducers';
const { location } = locationReducers;

import { createResponsiveStateReducer } from 'redux-responsive'
const responsiveStateReducer = createResponsiveStateReducer({
	small: 740,
	primaryViewLimit: 795,
	searchViewLimit: 916,
	placeReviewViewLimit: 1000,
	large: 1240,
	extra: Infinity
})

// timestamp of most recent incompatible change
// (new Date()).getTime()
const LATEST_SCHEMA_VERSION = 1497463942386
const rootReducer = combineReducers({
	schemaVersion: (state=LATEST_SCHEMA_VERSION, action) => state,
    mapState: mapStateReducers,
    userPosition: location,
  auth, cookie,
    profile,
    mapComponent,
    places,
    queries,
    routing,
    form: formReducer,
    account,
    browser: responsiveStateReducer
})

export { rootReducer, LATEST_SCHEMA_VERSION }



// WEBPACK FOOTER //
// ./src/app/models/reducers.ts